/** Shared helpers for Person display across assignee pickers (#65) */

export interface PersonOption {
  id: string;
  name: string;
  is_self?: boolean;
}

/** Sort people with self-person first, then alphabetical by name. */
export function sortPeopleWithSelf<T extends PersonOption>(people: T[]): T[] {
  return [...people].sort((a, b) => {
    if (a.is_self && !b.is_self) return -1;
    if (!a.is_self && b.is_self) return 1;
    return a.name.localeCompare(b.name);
  });
}

/** Return display name with "(Me)" suffix for self-person. */
export function displayName(person: PersonOption): string {
  return person.is_self ? `${person.name} (Me)` : person.name;
}

/** Return initials from a person's name (e.g., "Michael Kandy" → "MK"). */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.charAt(0).toUpperCase();
}
